import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { IInvoice } from 'app/models/invoices/invoice';
import { InvoiceService } from 'app/services/invoice-service';
import { LabService } from 'app/services/lab-service';
import { ILab } from 'app/models/labs/lab';
import { VoucherService } from 'app/services/voucher-service';
import { IVoucherSearchResult } from 'app/models/vouchers/voucher.search.result';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-invoices',
  templateUrl: './search-invoices.component.html',
  styleUrls: ['./search-invoices.component.scss']
})
export class SearchInvoicesComponent implements OnInit {

  labsControl = new FormControl('');
  filteredVouchers: Observable<IVoucherSearchResult[]>;
  filteredLabs: Observable<ILab[]>;

  pageSize = 20;
  processing = false;
  showResults = false;
  labs: ILab[] = [];
  vouchers: IVoucherSearchResult[];
  voucherType: string = '';

  displayedColumns: string[] = ['id', 'invoiceNumber', 'labName', 'pca', 'index', 'invoiceType', 'voucherType', 'voucherIdentifier', 'dueDate', 'paidDate', 'fiscalDate', 'amountDue', 'paymentComplete'];
  dataSource = new MatTableDataSource<IInvoice>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog,
    public invoiceService: InvoiceService,
    public labService: LabService,
    public voucherService: VoucherService,
    public oregonWellDataService: OregonWellDataService,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.processing = true;

    //load the labs
    this.labService.getLabs().subscribe(
      result => {
        this.labs = result;
        this.filteredLabs = this.labsControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterLabs(value || '')),
        );
        this.processing = false;
      },
      error => {
        this.toastr.error(error.message);
        this.processing = false;
      }
    );

    this.processing = false;
  }

  ngAfterViewInit() {
    // reload Search Results
    if (this.searchResultsCount > 0) {
      this.processing = true;

      this.showResults = true;
      this.dataSource = new MatTableDataSource<IInvoice>(this.invoiceService.searchResults);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.processing = false;
    }
  }

  private _filterLabs(value: string): ILab[] {
    const filterValue = value.toLowerCase();
    return this.labs.filter(option => option.labName.toLowerCase().includes(filterValue));
  }

  download() {
    this.setFormFields();
  }

  reset() {
    this.invoiceService.searchForm.reset({
      id: '',
      labName: '',
      pca: '',
      index: '',
      voucherType: '',
      voucherIdentifier: '',
      pastDue: false
    });

    this.labsControl.setValue('');
  }

  onSubmit() {
    this.setFormFields();
    this.processing = true;
    this.showResults = false;
    this.invoiceService.Search(this.invoiceService.search).subscribe(
      result => {
        this.invoiceService.searchResults = result;
        this.invoiceService.haveSearchResults = true;
        this.invoiceService.searchResultsCount = this.invoiceService.searchResults.length;
        this.searchResultsCount = this.invoiceService.searchResults.length;
        this.processing = false;
        this.showResults = true;
      },
      error => {
        this.processing = false;
        this.showResults = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<IInvoice>(this.invoiceService.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  setFormFields() {
    this.invoiceService.search.id = this.invoiceService.searchForm.value.id;
    this.invoiceService.search.labName = this.labsControl.value;
    this.invoiceService.search.pca = this.invoiceService.searchForm.value.pca;
    this.invoiceService.search.index = this.invoiceService.searchForm.value.index;
    this.invoiceService.search.voucherType = this.invoiceService.searchForm.value.voucherType;
    this.invoiceService.search.voucherIdentifier = this.invoiceService.searchForm.value.voucherIdentifier;
    this.invoiceService.search.pastDue = this.invoiceService.searchForm.value.pastDue;
    this.invoiceService.search.invoiceType = this.invoiceService.searchForm.value.invoiceType;
  }

  searchResults(): IInvoice[] {
    return this.invoiceService.searchResults;
  }

  searchResultsCount = this.invoiceService.searchResultsCount;
}